import {
  SET_SIDEBAR_CLOSE,
  SET_ACTIVE_TAB,
  SET_SCROLL_POSITION,
  useVideoUI,
  useVideoUIDispatch,
} from "../../VideoUIContext";
import { VideoUIActiveTab } from "../../videoUI.types";
import VideoUISidebar from "./VideoUISidebar";
import { PhaseAction } from "@platform/types/platform.types";
import { useChatUnreadCount } from "@platform/features/chat/hooks/useChatUnreadCount";

export type Props = {
  priorityBasedPolicy: boolean;
  sharingAttendeeId: string;
  meetingScriptUserPhaseAction: PhaseAction | null;
};

export function VideoUISidebarContainer({
  priorityBasedPolicy,
  sharingAttendeeId,
  meetingScriptUserPhaseAction,
}: Props) {
  const dispatch = useVideoUIDispatch();

  const { activeTab, scrollPositions } = useVideoUI();

  const unreadCount = useChatUnreadCount();

  const handleClose = () => {
    dispatch({ type: SET_SIDEBAR_CLOSE });
  };

  const handleTabChange = (tab: VideoUIActiveTab) => {
    dispatch({ type: SET_ACTIVE_TAB, payload: { activeTab: tab } });
  };

  const handleScrollPositionSave = (
    tab: VideoUIActiveTab,
    position: number
  ) => {
    dispatch({ type: SET_SCROLL_POSITION, payload: { tab, position } });
  };

  return (
    <VideoUISidebar
      activeTab={activeTab}
      scrollPositions={scrollPositions}
      priorityBasedPolicy={priorityBasedPolicy}
      sharingAttendeeId={sharingAttendeeId}
      onClose={handleClose}
      onTabChange={handleTabChange}
      onScrollPositionSave={handleScrollPositionSave}
      meetingScriptUserPhaseAction={meetingScriptUserPhaseAction}
      unreadCount={unreadCount}
    />
  );
}

export default VideoUISidebarContainer;
